import { useQuery } from '@tanstack/react-query';
import { fetchReviewData } from '../../api/projects';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';

export const reviewDataQueryKey = (fiscalYearQuarters: string[]) =>
  ['reviewData', fiscalYearQuarters] as const;

export function useReviewData(fiscalYearQuarters: string[]) {
  const { apiUrl } = useProductSettings<Settings>();

  return useQuery({
    queryKey: reviewDataQueryKey(fiscalYearQuarters),
    queryFn: () => fetchReviewData(apiUrl, fiscalYearQuarters),
    enabled: fiscalYearQuarters.length > 0,
  });
}
